<div class="kpi-card">
  <header class="kpi-card__header">
    <h3 class="kpi-card__title">{{ category }}</h3>
  </header>
  <section class="kpi-card__body">
    <ng-container *ngFor="let kpi of kpis | keyvalue: sortKpisByName; let i = index">
      <kpi
        *ngIf="kpi.value"
        [kpi]="kpi.value"
        [kpiKey]="getKpiKey(kpi.key)"
        [isSelected]="selectedKpiKey === getKpiKey(kpi.key)"
        [tooltipEnabled]="tooltipsEnabled"
        [keyMilestones]="keyMilestones"
        (kpiSelected)="handleKpiSelection($event)"
      ></kpi>
    </ng-container>
  </section>
</div>
